export const RegistrationResponseCodes = {
  'lumiq.registration.stop.user_already_exists':
    'This email address is already used for another account',
  'lumiq.registration.stop.identity_email_is_already_a_recovery_email':
    'This email address is already used for another account',
  'lumiq.registration.stop.email_domain_not_allowed':
    'Email domain not allowed',
} as const;

export const ForgotPasswordErrorCodes = {
  'lumiq.account_recovery.recovery_account.new_recovery_email_added_after_account_recovery_attempt_began':
    'Your recovery email has been changed. Please try again',
  'lumiq.account_recovery.recovery_account.recovery_email_associated_with_more_than_one_non_removed_user':
    'Something went wrong. Please try again or contact support',

  // This codes are typically swallowed by the FE
  'lumiq.account.reset_password.unknown_email':
    'This email address is not associated with any account',
  'lumiq.account_recovery.recovery_account.recovery_email_not_associated_with_any_non_removed_user':
    'This email address is not associated with any active account',
} as const;
